import { cva } from "@stubhub/broadway-foundation/css";

export const exploreButtonRecipe = cva({
  base: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: "primitives.50",
    paddingBlock: "primitives.75",
    paddingInline: "primitives.150",
    borderStartStartRadius: "primitives.100",
    borderStartEndRadius: "primitives.100",
    borderEndStartRadius: "primitives.100",
    borderEndEndRadius: "primitives.100",
    color: "text.brand",
    fontWeight: "medium",
    fontSize: "[14px]",
    textDecorationLine: "none",
    backgroundColor: "[white]",
    transitionProperty: "[all]",
    transitionDuration: "[0.3s]",
    transitionTimingFunction: "[ease]",
    whiteSpace: "nowrap",
    "& [data-icon]": {
      display: "inline-flex",
      alignItems: "center",
      width: "primitives.0",
      overflowX: "hidden",
      transitionProperty: "[width]",
      transitionDuration: "[0.3s]",
      transitionTimingFunction: "[ease]",
    },
    _hover: {
      backgroundColor: "bg.fill.brand",
      color: "[white]",
      "& [data-icon]": {
        width: "primitives.200",
      },
    },
  },
  variants: {
    border: {
      visible: {
        borderBlockStartWidth: "primitives.25",
        borderBlockEndWidth: "primitives.25",
        borderInlineStartWidth: "primitives.25",
        borderInlineEndWidth: "primitives.25",
        borderBlockStartStyle: "[solid]",
        borderBlockEndStyle: "[solid]",
        borderInlineStartStyle: "[solid]",
        borderInlineEndStyle: "[solid]",
        borderBlockStartColor: "bg.fill.brand",
        borderBlockEndColor: "bg.fill.brand",
        borderInlineStartColor: "bg.fill.brand",
        borderInlineEndColor: "bg.fill.brand",
      },
      hidden: {
        borderBlockStartWidth: "primitives.0",
        borderBlockEndWidth: "primitives.0",
        borderInlineStartWidth: "primitives.0",
        borderInlineEndWidth: "primitives.0",
      },
    },
  },
  defaultVariants: {
    // eslint-disable-next-line panda/prefer-atomic-properties -- variant name, not a CSS property
    border: "visible",
  },
});
